<template>
    <ListeEtudiant/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import ListeEtudiant from "@/components/Etudiant/ListeEtudiant.vue";

    export default defineComponent({
      name: "ListeEtudiantPage",
      components: {
        
        ListeEtudiant,
      },
    });
  </script>